import StudySign from './StudySign.vue';
export default StudySign;
